"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AuthWindowBlockedError = void 0;
var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));
var _AuthError2 = require("./AuthError");
var AuthWindowBlockedError = /*#__PURE__*/function (_AuthError) {
  (0, _inheritsLoose2.default)(AuthWindowBlockedError, _AuthError);
  function AuthWindowBlockedError(params) {
    var _ref = params || {},
      _ref$message = _ref.message,
      message = _ref$message === void 0 ? "Child window for authentication was blocked" : _ref$message;
    return _AuthError.call(this, {
      message
    }) || this;
  }
  return AuthWindowBlockedError;
}(_AuthError2.AuthError);
exports.AuthWindowBlockedError = AuthWindowBlockedError;